<template>
  <div class="main">
    <topback title="Mine"></topback>
    <div class="content">
      <md-field class="userinfo">
        <md-cell-item :title="this.$store.state.userinfo.name"
                      :brief="'Reward ratio:' + this.$store.state.userinfo.payee_reward_ratio" arrow>
          <span slot="right" @click="gorouter('accountinfo')">ID: {{this.$store.state.userinfo.collectionworkerid}}</span>
          <span class="avatar" slot="left"><img src="/static/images/avatar.png" alt=""/></span>
        </md-cell-item>
      </md-field>
      <md-field class="menu">
        <md-cell-item title="I Token" @click="gorouter('transaction')">
          <div class="holder" slot="left">
            <iconimg name="i" class="assetslist-img"></iconimg>
          </div>
          <span slot="right">
            <span style="color: #f0b90b;">{{ $store.state.userinfo.itoken }} IToken</span> Buy
          </span>
        </md-cell-item>
        <md-cell-item title="Sell" arrow @click="gorouter('sell')" :addon="in_sell">
          <div class="holder" slot="left">
            <iconimg name="registersuccess" size="lg"></iconimg>
          </div>
        </md-cell-item>
        <md-cell-item title="Sell History" arrow @click="gorouter('sellhistory')">
          <div class="holder" slot="left">
            <iconimg name="edit" size="lg"></iconimg>
          </div>
        </md-cell-item>
        <md-cell-item title="Buy History" arrow @click="gorouter('deposithistory')">
          <div class="holder" slot="left">
            <iconimg name="deposithistory" size="lg"></iconimg>
          </div>
        </md-cell-item>
        <md-cell-item title="Itoken History" arrow @click="gorouter('itokenhistory')">
          <div class="holder" slot="left">
            <iconimg name="i" size="lg"></iconimg>
          </div>
        </md-cell-item>
        <md-cell-item title="UPI KYC Partner" arrow @click="gorouter('kycpartner')">
          <div class="holder" slot="left">
            <iconimg name="upi" size="lg"></iconimg>
          </div>
        </md-cell-item>
        <md-cell-item title="Bank KYC Partner" arrow @click="gorouter('bank')">
          <div class="holder" slot="left">
            <iconimg name="bank" size="lg"></iconimg>
          </div>
        </md-cell-item>
        <md-cell-item title="Promote more revenue" arrow @click="gorouter('agent')">
          <div class="holder" slot="left">
            <iconimg name="agent" size="lg"></iconimg>
          </div>
        </md-cell-item>
        <md-cell-item title="Tutorial" arrow @click="gorouter('tutorial')">
          <div class="holder" slot="left">
            <md-icon name="rectangle" size="lg"></md-icon>
          </div>
        </md-cell-item>
        <md-cell-item title="Message" arrow @click="gorouter('message')">
          <div class="holder" slot="left">
            <iconimg name="deposithistory" size="lg"></iconimg>
          </div>
          <md-tag slot="right"
            size="large"
            shape="bubble"
            fill-color="linear-gradient(90deg, #FF5B60 0%, #F98472 100%)"
            type="fill"
            v-if="$store.state.unread_count > 0"
          >{{ $store.state.unread_count }}</md-tag>
        </md-cell-item>
        <md-cell-item title="Official Service" @click="gorouter('customerservice')" arrow>
          <div class="holder" slot="left">
            <iconimg name="service" size="lg"></iconimg>
          </div>
        </md-cell-item>
      </md-field>
      <md-button @click="singnup" class="signoutbtn">Sign Out</md-button>
    </div>
    <navbar></navbar>
 <Dragball />
  </div>
</template>

<script>
import navbar from '@/components/navbar.vue'
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import Dragball from '../../components/dragball.vue'

export default {
  name: 'My',
  components: {
    [navbar.name]: navbar,
    [topback.name]: topback,
    [iconimg.name]: iconimg,
    Dragball
  },
  data() {
    return {
      in_sell: ""
    }
  },
  created() {
    this.$store.dispatch('asyncupdateuserinfo').then(res => {
      if (res.in_sell) {
        this.in_sell = 'Stop Sell';
      } else {
        this.in_sell = 'Open Sell';
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      const footerNavHeight = this.$el.querySelector('.footer_nav').offsetHeight;
      this.$el.querySelector('.content').style.paddingBottom = footerNavHeight + 'px';
    });
  },
  methods: {
    singnup() {
      let that = this;
      that.$dialog.confirm({
        title: 'Confirm Exit',
        content: 'Confirm to log out ?',
        cancelText: 'Cancel',
        confirmText: 'Confirm',
        onConfirm: () => {
          localStorage.removeItem("token")
          that.$router.push('/login')
        },
      })
    },

    gorouter(name) {
      this.$router.push({"name": name})
    }
  },
}
</script>

<style scoped>
.userinfo {
  padding-bottom: 0;
  margin-top: 0.7rem;
}

.menu {
  padding-top: 10px
}

.avatar {
  display: block;
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: #E6E6E6;
}

.avatar img {
  display: block;
  width: 88px;
  height: 88px;
  border-radius: 44px;
  background-color: #E6E6E6;
}

.holder {
  line-height: 0px;
  font-size: 39px;
}

.signoutbtn {
  background-color: #aaa;
}

.userinfo >>> .md-cell-item-brief {
  width: 3rem;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/my/my.vue